var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopoComponent',{attrs:{"empresa":_vm.nomeempresa}}),_c('h3',[_vm._v("Redirecionando ...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }